/* eslint import/namespace: ['error', { allowComputed: true }] */
/* prevent error on process things on urlParams ^ */
import {
  replace,
} from 'connected-react-router';
import { generatePath } from 'react-router';
import {
  all,
  call,
  delay,
  fork,
  put,
  race,
  select,
  take,
} from 'redux-saga/effects';
import ApiResource from '../api-resources';
import Routes from '../routes';
import { credentialsSelector } from '../selectors';
import { conversationWithMessagesSelector } from '../selectors/conversations';
import { createSuccessActionType } from '../utils/actions';
import { rollbar } from '../utils/dev-tools';
import * as urlParams from '../utils/url-parser';
import { getPathnameId } from '../utils/routes';
import { handleFollowingReferralInvitation } from './navigation';

const pipeline = [
  { key: 'referee_code', saga: handleFollowingReferralInvitation },
  { key: 'signin', saga: handleSigninRequest },
  { key: 'modal', saga: handleModalOpen },
];

/**
 * Hub to display requested modals from above pipeline
 */
export function* initializeFromUrl() {
  yield all(pipeline.map(pipe => {
    if (urlParams[pipe.key]) {
      return call(pipe.saga, urlParams[pipe.key]);
    }
  }));
}

/**
 * Handle request of opening signin modal from url
 * @param {String} signinFlow - Name of the signup flow (authorized: 'students', 'mentors')
 */
export function* handleSigninRequest(flow) {
  if (['students'].indexOf(flow) === -1) {
    rollbar('User try to load not allowed signin modal', 'error', { modal: flow });
    return;
  }
  const credentials = yield select(credentialsSelector);
  if (credentials) {
    return;
  }
  yield put(replace(Routes.signinView));
}

/**
 * Handle the modal opening
 * @param {String} modalName
 */
export function* handleModalOpen(modalName) {
  if (modalName === 'book-appointment') {
    const { locationAction } = yield race({
      locationAction: take('@@router/LOCATION_CHANGE'),
      // just in case this saga call after location already changed
      fallback: delay(2000),
    });
    const conversationId = getPathnameId(Routes.conversation, locationAction?.payload?.pathname || '');
    if (conversationId) {
      yield fork(function*() {
        let conversation = yield select(conversationWithMessagesSelector(conversationId));
        if (!conversation) {
          yield take(createSuccessActionType('READ', ApiResource.MESSAGING_CONVERSATION));
          conversation = yield select(conversationWithMessagesSelector(conversationId));
        }
        if (!conversation?.appointment?.id) {
          yield put(replace(generatePath(Routes.bookAppointment, { id: conversationId })));
        }
      });
    }
  }
}
